import { RecursiveStringifyEnums } from './buildDistro';
import { Integration } from './../types';

export const iosIntegrations: RecursiveStringifyEnums<Integration[]> = [];

export const otaIntegrations: RecursiveStringifyEnums<Integration[]> = [];

export const androidIntegrations: RecursiveStringifyEnums<Integration[]> = [
    {
        capabilities: ['appStore'],
        data: {
            packageName: 'com.example.demo',
            availableTracks: ['track1', 'track2'],
        },
        id: 'google',
        installationId: 'google:12345',
        integrationError: null,
        name: 'Google Play',
        providerId: 'google:abcdefg',
        refreshData: [
            {
                integrationId: 'google',
                lastRefreshedAt: '2023-06-22T13:14:15.757865804Z',
                nextRefreshAt: '2023-06-22T13:37:15.757818406Z',
            },
        ],
    },
    {
        capabilities: ['betaTesting'],
        data: {
            packageName: 'com.example.demo',
            testingTrack: 'internal',
            availableTracks: ['internal', 'alpha', 'beta', 'production'],
            consoleUrl: 'https://play.google.com/console',
        },
        id: 'google-beta',
        installationId: 'google-beta:12345',
        integrationError: null,
        name: 'Google Play beta',
        providerId: 'google:abcdefg',
        refreshData: [
            {
                integrationId: 'google-beta',
                lastRefreshedAt: '2023-06-22T13:14:15.757865804Z',
                nextRefreshAt: '2023-06-22T13:37:15.757818406Z',
            },
        ],
    },
];
